import React, { useState, useEffect } from "react";
import cn from "classnames";
import Card from "../../../components/Card";
import styles from "./Products.module.sass";
import Icon from "../../../components/Icon";
import FolderCardCompany from "../../../components/FolderCardCompany";
import Slider from "react-slick";

// data
import { useAuth } from "../../../contexts/AuthContext";
import { getFoldersByCompanyId } from "../../../services/folder.service";
import { getCompanyForCurrentUser } from "../../../services/company.service";

const SlickArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <button {...props}>{children}</button>
);

const Products = ({className}) => {
  const { currentUser } = useAuth();
  const [folders, setFolders] = useState([]);
  const [loading, setLoading] = useState(true);

const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    nextArrow: (
      <SlickArrow>
        <Icon name="arrow-right" size="24" />
      </SlickArrow>
    ),
    prevArrow: (
      <SlickArrow>
        <Icon name="arrow-left" size="24" />
      </SlickArrow>
    ),
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 1.5,
        },
      },
    ],
  };

  useEffect(() => {
    const fetchFolders = async () => {
      try {
        setLoading(true);
        // Récupérer l'entreprise connectée
        const company = await getCompanyForCurrentUser();
        if (company?.id) {
          // Récupérer les folders de cette entreprise
          const companyFolders = await getFoldersByCompanyId(company.id);
          setFolders(companyFolders);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des folders:', error);
        setFolders([]);
      } finally {
        setLoading(false);
      }
    };

    if (currentUser) {
      fetchFolders();
    }
  }, [currentUser]);

  if (loading) {
    return (
      <Card
        className={cn(styles.card, className)}
        title={`Votre tableau de bord, ${currentUser?.first_name || 'Utilisateur'}`}
        classTitle={cn("title-blue", styles.cardTitle)}
        classCardHead={styles.cardHead}
      >
        <div className={styles.products}>
          <div className={styles.wrapper}>
            <p>Chargement de vos dossiers...</p>
          </div>
        </div>
      </Card>
    );
  }

  if (folders.length === 0) {
    return (
      <Card
        className={cn(styles.card, className)}
        title={`Votre tableau de bord, ${currentUser?.first_name || 'Utilisateur'}`}
        classTitle={cn("title-blue", styles.cardTitle)}
        classCardHead={styles.cardHead}
      >
        <div className={styles.products}>
          <div className={styles.empty}>
            Aucun dossier trouvé.
          </div>
        </div>
      </Card>
    );
  }

  return (
    <Card
      className={cn(styles.card, className)}
      title={`Votre tableau de bord, ${currentUser?.first_name || 'Utilisateur'}`}
      classTitle={cn("title-blue", styles.cardTitle)}
      classCardHead={styles.cardHead}
    >
      <div className={styles.products}>
        <div className={styles.wrapper}>
          <Slider className="products-slider" {...settings}>
            {folders.map((folder, index) => (
              <FolderCardCompany
                className={styles.product}
                item={folder}
                key={folder.id || index}
                withoutСheckbox
              />
            ))}
          </Slider>
        </div>
      </div>
    </Card>
  );
};

export default Products;
